import { GitBranch, ArrowUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { SideJobReport } from '../lib/sideJobReport'
import MarkdownBody from './MarkdownBody'

export default function SideJobReportBody({ report }: { report: SideJobReport }) {
  return (
    <div className="max-w-prose space-y-3">
      <h3 className="flex flex-wrap items-center gap-x-2 gap-y-1 font-semibold text-teal-900 dark:text-teal-100">
        <GitBranch className="h-4 w-4 shrink-0" aria-hidden="true" />
        Side job report
        {report.kind === 'formatted' && (
          <span className={report.outcome === 'failed' ? 'text-red-700 dark:text-red-300' : 'font-normal'}>
            · {report.outcome === 'failed' ? 'Failed' : 'Finished'}
          </span>
        )}
      </h3>
      {report.kind === 'formatted' && (
        <div>
          <p className="font-medium">{report.title}</p>
          <Link
            to={report.topicPath}
            className="inline-flex min-h-11 items-center gap-1 font-medium text-teal-800 underline underline-offset-4 dark:text-teal-200 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
          >
            Open side chat <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      )}
      <MarkdownBody body={report.body} />
    </div>
  )
}
